import { Config } from './type';

import config from './config/out/config.client.json';

const typed: Config = config;

export default typed;
